export const environment = {
  production: false,
  appType: 'sales',
  appTitle: 'WP Sales',
  authBaseUrl: '/api/v1/wp/sales/auth/',
  saleshubPdfUrl: 'https://dev-saleshub.idfood.co.id/api/f_trans/c_subsidiary_inventory_sales_order/create_pdf_so',
  qrDomain: 'https://dev-warungpangan.idfood.co.id'
};
